import { useCallback } from 'react'

export function useFormStateController(setEditingState: (inEditing: boolean) => void) {
  const cancel = useCallback(() => setEditingState(false), [setEditingState])
  const edit = useCallback(() => setEditingState(true), [setEditingState])

  return { edit, cancel }
}
